import { client }  from '../util/createRestApiClient';
import { loading } from "./index";

const base = "investigationComment/";
export default () => ({
    getInvestigationComment: (id) => client.request({
      method: 'GET',
      url: base + 'getInvestigationComment/' + id
    }),
    getInvestigationComments: (investigationId, limit = 10, skip = 0, filterName = "", columnSort = "", descending = true) => loading(client.request({
      method: 'GET',
      url: base + 'GetInvestigationComments/' + investigationId + '?limit=' + limit + '&skip=' + skip + '&filter=' + filterName + '&columnSort=' + columnSort + '&descending=' + descending
    })),
    addInvestigationComment: (params) => client.request({
      method: 'POST',
      url: base + 'addInvestigationComment',
      data: params
    }),
    updateInvestigationComment: (params) => client.request({
      method: 'PUT',
      url: base + 'UpdateInvestigationComment/' + params.id,
      data: params
    }),
    deleteInvestigationComment: (params) => client.request({
      method: 'DELETE',
      url: base + 'deleteInvestigationComment/' + params.id
    })
  }
);
